module.exports = __webpack_public_path__ + "media/images/payments/cirrus-bc2544cd2f721336d296767abb2468bc.svg";